import { useContext } from 'react';
import { MessageContext } from '../providers/MessageProvider';
function usePortalMessenger() {
    return useContext(MessageContext);
}
export default usePortalMessenger;
